<template>
  <div class="main_profile_wrapper">
    <div class="main_table">
      <TableHeaderSection
        v-if="hasPermission('create students_notebook')"
        :title="`${localization('Students Notebook')}`"
        :text="`${localization('Browse your students notebooks.')}`"
        :buttonText="`${localization('Create new notebook')}`"
        :total="totalStudentsNotebooks"
        @toggleModal="createNotebook"
      ></TableHeaderSection>
      <div class="header_container just_custom_table_tasks">
        <CustomTable
          ref="customTable"
          :count="totalStudentsNotebooks"
          :DataItems="studentsNotebooks"
          @Refresh="Refresh"
          @reset="resetFilters"
          :filter="filter"
          :title="'students_notebooks'"
          hidden_export_import
          @reset-filters="resetFilters"
          viewName="StudentsNotebooks"
        >
          <template #filter>
            <div class="d-flex flex-wrap" style="gap: 10px;">
              <el-select
                v-model="filter.language_id"
                clearable
                filterable
                class="filter_select"
                :placeholder="`${localization('Language')}`"
                @change="Refresh"
              >
                <el-option
                  v-for="item in computedLanguageOptions"
                  :key="item.id"
                  :label="getLanguageLabel(item)"
                  :value="item.id"
                />
              </el-select>
            </div>
          </template>
          <template #columns>
            <el-table-column
              prop="name"
              :label="`${localization('Name')}`"
              align="left"
              header-align="left"
              sortable
            >
              <template #default="{ row }">
                <div class="font-weight-600">
                  {{ row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="school_grade"
              :label="`${localization('Grade')}`"
              width="120"
              align="left"
              header-align="left"
              sortable
            >
              <template #default="{ row }">
                <el-tag size="small" type="info" v-if="row.school_grade">
                  {{ localization('Grade') }} {{ row.school_grade }}
                </el-tag>
                <span v-else class="text-muted">-</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="language_id"
              :label="`${localization('Language')}`"
              align="left"
              header-align="left"
              sortable
            >
              <template #default="{ row }">
                <el-tag size="small" type="warning" v-if="getLanguageName(row)">
                  {{ getLanguageName(row) }}
                </el-tag>
                <span v-else class="text-muted">-</span>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="topic_card_name"
              :label="`${localization('Topic')}`"
              align="left"
              header-align="left"
              sortable
            >
              <template #default="{ row }">
                <div>
                  {{ row.topic_card_name || '-' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="sub_topic_card_name"
              :label="`${localization('Subtopic')}`"
              align="left"
              header-align="left"
              sortable
            >
              <template #default="{ row }">
                <el-tag size="small" type="success" v-if="row.sub_topic_card_name">
                  {{ row.sub_topic_card_name }}
                </el-tag>
                <span v-else class="text-muted">-</span>
              </template>
            </el-table-column> -->
            <el-table-column
              prop=""
              label="actions"
              width="180"
              align="left"
              header-align="left"
            >
              <template slot-scope="scope">
                <div class="td-actions">
                  <span>
                    <a
                      v-if="hasPermission('view students_notebook')"
                      v-tooltip.top-center="`${localization('Show')}`"
                      @click="$router.push({ name: localization('Students Notebook Details'), params: { id: scope.row.id } })"
                    >
                      <img
                        role="button"
                        src="@/assets/new-theme/eye.png"
                        alt="eye"
                        class="mx-2"
                      />
                    </a>
                    <a
                      v-if="hasPermission('edit students_notebook')"
                      v-tooltip.top-center="`${localization('Edit')}`"
                      @click="editNotebook(scope.row)"
                    >
                      <img
                        role="button"
                        src="@/assets/new-theme/edit.png"
                        alt="edit"
                        class="mr-2"
                      />
                    </a>
                    <a
                      v-if="hasPermission('delete students_notebook')"
                      v-tooltip.top-center="`${localization('Delete')}`"
                      @click="deleteNotebook(scope.row.id)"
                    >
                      <img
                        role="button"
                        src="@/assets/new-theme/delete-button-table.png"
                        alt="delete"
                      />
                    </a>
                  </span>
                </div>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
    </div>

    <!-- Create/Edit Students Notebook Modal -->
    <el-dialog
      @close="resetForm"
      :title="isEdit ? localization('Update notebook') : localization('Create new notebook')"
      :visible.sync="dialogVisible"
      width="850px"
      top="1%"
      custom-class="task-modal global_modal"
      :close-on-click-modal="false"
    >
      <div class="custom_modal_header">
        <div class="images">
          <img src="@/assets/new-theme/icons/users-plus.png" alt="file" />
          <img
            @click="resetForm"
            class="close_img"
            src="@/assets/new-theme/x-close-modal.png"
            alt="file"
          />
        </div>
        <h3 class="title font-weight-bold mt-3">
          {{ isEdit ? localization("Update notebook") : localization("Create new notebook") }}
        </h3>
        <p class="description">
          {{ localization("Select the grade, language, topic, subtopic and enter notebook HTML body.") }}
        </p>
      </div>

      <el-form
        :rules="rules"
        ref="addNotebookForm"
        :model="form"
        label-position="top"
        @submit.native.prevent
      >
        <!-- Grade and Language Selection -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="`${localization('Student Grade')}*`"
              prop="school_grade"
            >
              <el-select
                v-model="form.school_grade"
                class="w-100"
                filterable
                :placeholder="`${localization('Select Grade')}`"
              >
                <el-option
                  v-for="grade in ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']"
                  :key="grade"
                  :label="`${localization('Grade')} ${grade}`"
                  :value="grade"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="`${localization('Language')}`"
              prop="language_id"
            >
              <el-select
                v-model="form.language_id"
                clearable
                filterable
                class="w-100"
                :placeholder="`${localization('Select Language')}`"
              >
                <el-option
                  v-for="item in computedLanguageOptions"
                  :key="item.id"
                  :label="getLanguageLabel(item)"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Topic and Subtopic Selection -->
        <!-- <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="`${localization('Topic')}*`"
              prop="topic_card_id"
            >
              <el-select
                v-model="form.topic_card_id"
                filterable
                class="w-100"
                :placeholder="`${localization('Select Topic')}`"
                @change="handleTopicChange"
              >
                <el-option
                  v-for="item in topicsCardLookups"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="`${localization('Subtopic')}*`"
              prop="sub_topic_card_id"
            >
              <el-select
                v-model="form.sub_topic_card_id"
                filterable
                class="w-100"
                :disabled="!form.topic_card_id"
                :placeholder="form.topic_card_id ? `${localization('Select Subtopic')}` : `${localization('Choose a Topic first')}`"
              >
                <el-option
                  v-for="item in subTopicsCardLookups"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->

        <!-- Notebook Name -->
        <el-form-item
          :label="`${localization('Notebook Name')}*`"
          prop="name"
        >
          <el-input
            :placeholder="`${localization('Enter notebook name')}`"
            v-model="form.name"
          ></el-input>
        </el-form-item>

        <!-- Body (Rich HTML Editor) -->
        <el-form-item
          :label="`${localization('Body (HTML Content)')}`"
          prop="body"
        >
          <editor
            api-key="uwhpqwb5bkozdxtejm40jkuwvcy2u2kp98feem6n6y33fhzu"
            v-model="form.body"
            :init="editorInit"
          />
        </el-form-item>

      </el-form>
      <div class="lci_modal_buttons mt-5">
        <button @click="resetForm" class="lci_btn_modal_cancel">
          {{ localization("Cancel") }}
        </button>
        <button @click="submitForm" class="lci_btn save lci_btn_modal_cancel">
          {{ isEdit ? localization("Update") : localization("Create") }}
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import Editor from "@tinymce/tinymce-vue";

export default {
  name: "StudentsNotebookIndex",
  components: {
    editor: Editor
  },
  data() {
    return {
      filter: {
        language_id: ""
      },
      languageOptions: [],
      dialogVisible: false,
      isEdit: false,
      selectedId: null,
      editorInit: {
        height: 380,
        mode: "none",
        menubar: false,
        dialog_type: "modal",
        importcss_append: true,
        relative_urls: false,
        remove_script_host: false,
        convert_urls: false,
        language: "en",
        zIndex: 10000,
        toolbar:
          "undo redo | bold italic underline | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | fullscreen code | numlist bullist | forecolor backcolor | table | ltr rtl",
        plugins: [
          "table charmap preview fullscreen importcss textpattern code"
        ]
      },
      form: {
        name: "",
        school_grade: "",
        language_id: null,
        topic_card_id: null,
        sub_topic_card_id: null,
        body: ""
      }
    };
  },
  computed: {
    ...mapGetters("students_notebook", [
      "studentsNotebooks",
      "totalStudentsNotebooks",
      "loading"
    ]),
    ...mapGetters("topics_card", ["topicsCardLookups"]),
    ...mapGetters("sub_topics_card", ["subTopicsCardLookups"]),
    computedLanguageOptions() {
      if (this.languageOptions && this.languageOptions.length) {
        return this.languageOptions;
      }
      const all = this.$store.getters["language/allLanguages"];
      if (all && all.length) return this.normalizeLanguages(all);
      const langs = this.$store.getters["language/languages"];
      if (langs && langs.length) return this.normalizeLanguages(langs);
      return [];
    },
    rules() {
      return {
        name: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ],
        school_grade: [
          {
            required: true,
            message: this.localization("Please select a grade"),
            trigger: "change"
          }
        ],
        topic_card_id: [
          {
            required: true,
            message: this.localization("Please select a topic"),
            trigger: "change"
          }
        ],
        sub_topic_card_id: [
          {
            required: true,
            message: this.localization("Please select a subtopic"),
            trigger: "change"
          }
        ]
      };
    }
  },
  methods: {
    Refresh(query) {
      if (arguments.length > 0 && query && typeof query === "object" && Object.keys(query).length > 0) {
        this.$store.dispatch("students_notebook/GetStudentsNotebooks", { query: query });
      } else if (this.$refs.customTable && typeof this.$refs.customTable.Refresh === "function") {
        this.$refs.customTable.Refresh();
      } else {
        this.$store.dispatch("students_notebook/GetStudentsNotebooks", { query: {} });
      }
    },
    resetFilters() {
      this.filter = {
        language_id: ""
      };
      this.$nextTick(() => {
        this.Refresh();
      });
    },
    getLanguageLabel(item) {
      if (!item) return "";
      return item.title || item.name || item.label || item.language || "";
    },
    getLanguageName(row) {
      if (!row) return "";
      if (row.language_name && typeof row.language_name === "string" && isNaN(row.language_name)) {
        return row.language_name;
      }
      if (row.language && typeof row.language === "string" && isNaN(row.language)) {
        return row.language;
      }
      if (row.language && typeof row.language === "object") {
        const label = row.language.title || row.language.name || row.language.label || row.language.language;
        if (label) return label;
      }

      const langId = row.language_id != null && row.language_id !== "" 
        ? row.language_id 
        : (row.language != null && row.language !== "" ? row.language : null);

      if (langId != null) {
        const options = this.computedLanguageOptions;
        if (options && options.length) {
          const found = options.find(l => String(l.id) === String(langId) || String(l.title).toLowerCase() === String(langId).toLowerCase());
          if (found) {
            return this.getLanguageLabel(found);
          }
        }
        if (isNaN(langId)) {
          return String(langId);
        }
      }
      return "";
    },
    normalizeLanguages(response) {
      if (Array.isArray(response)) {
        return response;
      }

      if (!response || typeof response !== "object") {
        return [];
      }

      if (Array.isArray(response.languages)) {
        return response.languages;
      }

      if (response.data && Array.isArray(response.data.languages)) {
        return response.data.languages;
      }

      if (response.data && Array.isArray(response.data)) {
        return response.data;
      }

      return [];
    },
    async fetchLookups() {
      try {
        await this.$store.dispatch("topics_card/GetTopicsCardLookups");
      } catch (e) {
        console.error("Topics lookups error:", e);
      }

      let options = [];
      try {
        const langsResponse = await this.$store.dispatch("language/allLanguages");
        options = this.normalizeLanguages(langsResponse);
      } catch (e) {
        console.warn("allLanguages error, trying getLanguages:", e);
      }

      if (!options || !options.length) {
        try {
          await this.$store.dispatch("language/getLanguages");
          const fallbackLangs = this.$store.getters["language/languages"];
          options = this.normalizeLanguages(fallbackLangs);
        } catch (e) {
          console.error("Fallback getLanguages error:", e);
        }
      }

      this.languageOptions = options || [];
    },
    handleTopicChange(topicId) {
      this.form.sub_topic_card_id = null;
      if (topicId) {
        this.$store.dispatch("sub_topics_card/GetSubTopicsCardLookups", { topic_card_id: topicId });
      }
    },
    createNotebook() {
      this.isEdit = false;
      this.resetForm();
      this.dialogVisible = true;
    },
    editNotebook(row) {
      this.isEdit = true;
      this.selectedId = row.id;

      let langId = null;
      if (row.language_id != null && row.language_id !== "") {
        langId = isNaN(row.language_id) ? row.language_id : Number(row.language_id);
      } else if (row.language && row.language.id != null) {
        langId = isNaN(row.language.id) ? row.language.id : Number(row.language.id);
      } else if (row.language != null && row.language !== "") {
        langId = isNaN(row.language) ? row.language : Number(row.language);
      }

      this.form = {
        name: row.name || "",
        school_grade: row.school_grade ? String(row.school_grade) : "",
        language_id: langId,
        topic_card_id: row.topic_card_id || null,
        sub_topic_card_id: row.sub_topic_card_id || null,
        body: row.body || row.student_notebook || ""
      };
      if (this.form.topic_card_id) {
        this.$store.dispatch("sub_topics_card/GetSubTopicsCardLookups", { topic_card_id: this.form.topic_card_id });
      }
      this.dialogVisible = true;
    },
    resetForm() {
      this.form = {
        name: "",
        school_grade: "",
        language_id: null,
        // topic_card_id: null,
        // sub_topic_card_id: null,
        body: ""
      };
      this.selectedId = null;
      this.isEdit = false;
      this.dialogVisible = false;
    },
    submitForm() {
      this.$refs.addNotebookForm.validate((valid) => {
        if (valid) {
          const action = this.isEdit
            ? "students_notebook/UpdateStudentsNotebook"
            : "students_notebook/CreateStudentsNotebook";

          const langId = this.form.language_id != null && this.form.language_id !== ""
            ? (isNaN(this.form.language_id) ? this.form.language_id : Number(this.form.language_id))
            : null;

          const formPayload = {
            name: this.form.name,
            school_grade: this.form.school_grade,
            language_id: langId,
            language: langId,
            topic_card_id: this.form.topic_card_id,
            sub_topic_card_id: this.form.sub_topic_card_id,
            body: this.form.body,
            student_notebook: this.form.body
          };

          const payload = this.isEdit
            ? { id: this.selectedId, form: formPayload }
            : formPayload;

          this.$store
            .dispatch(action, payload)
            .then(() => {
              this.resetForm();
              Swal.fire({
                title: "",
                icon: "success",
                text: `${this.localization("Done")}`,
                confirmButtonText: `${this.localization("Ok")}`,
                type: "success",
                confirmButtonClass: "btn btn-success",
                buttonsStyling: false
              });
              this.$store.dispatch("students_notebook/GetStudentsNotebooks", { query: {} });
              if (this.$refs.customTable && typeof this.$refs.customTable.Refresh === "function") {
                this.$refs.customTable.Refresh();
              }
            })
            .catch((error) => {
              Swal.fire({
                title: "",
                icon: "error",
                text: (error && error.response && error.response.data && error.response.data.message) || this.localization("Something went wrong"),
                confirmButtonText: `${this.localization("Ok")}`,
                confirmButtonClass: "btn btn-danger",
                buttonsStyling: false
              });
            });
        }
      });
    },
    deleteNotebook(id) {
      Swal.fire({
        title: "",
        text: `${this.localization("Are You Sure")}`,
        type: "warning",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        confirmButtonText: `${this.localization("Delete")}`,
        cancelButtonText: `${this.localization("Cancel")}`,
        buttonsStyling: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("students_notebook/DeleteStudentsNotebook", id).then(() => {
            this.$store.dispatch("students_notebook/GetStudentsNotebooks", { query: {} });
            if (this.$refs.customTable && typeof this.$refs.customTable.Refresh === "function") {
              this.$refs.customTable.Refresh();
            }
            Swal.fire({
              title: "",
              icon: "success",
              type: "success",
              text: `${this.localization("Deleted")}`,
              confirmButtonText: `${this.localization("Ok")}`,
              confirmButtonClass: "btn btn-success",
              buttonsStyling: false
            });
          });
        }
      });
    }
  },
  mounted() {
    this.fetchLookups();
    this.Refresh({});
  }
};
</script>

<style lang="scss" scoped>
.main_profile_wrapper {
  background: #fff;
  width: 100%;
  max-width: 100%;
  padding: 0 30px 50px;
}
.main_table {
  margin-top: 30px;
  border-radius: 8px;
  border: 1px solid #eaecf0;

  .head_table {
    border-bottom: 1px solid #eaecf0;
  }
}

.lci_modal_buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3%;
  .lci_btn_modal_cancel {
    background-color: #fff;
    color: #667085;
    border-radius: 8px;
    padding: 12px 20px;
    border: 1px solid #eaecf0;
    width: calc(97% / 2);
    &.save {
      background-color: #7f56d9;
      color: #fff;
    }
  }
}
</style>

<style scoped>
::v-deep .el-table .cell {
  padding-left: 20px !important;
}

::v-deep .el-form--label-top .el-form-item__label {
  float: none;
  display: inline-block;
  text-align: left;
  padding: 0 !important;
  font-weight: 600;
  color: #344054;
}
</style>

<style lang="scss">
.tox-tinymce-aux {
  z-index: 10000 !important;
}
</style>
